import React, { useState } from 'react';
import './PersonalLoan.css';
import PersonalLoanBanner from '../images/personal-loan.jpg';
import PersonalLoanBody from '../images/personal-loan2.jpeg';

const PersonalLoan = () => {
  const [activeTab, setActiveTab] = useState('eligibility');

  return (
    <div className="personal-loan-page" style={{ backgroundImage: `url(${PersonalLoanBody})` }}>
      {/* Banner Section */}
      <section className="personal-loan-banner">
        <div className="personal-banner-container">
          <div className="personal-banner-left">
            <div className="personal-banner-image" style={{ backgroundImage: `url(${PersonalLoanBanner})` }}>
              <div className="personal-image-overlay">
                <h1 className="personal-banner-title">PERSONAL LOAN</h1>
              </div>
            </div>
          </div>
          <div className="personal-banner-right">
            <div className="personal-banner-content">
              <h2 className="personal-banner-subtitle">WE OFFER A FULL RANGE OF PERSONAL LOAN SERVICES</h2>
              <p className="personal-banner-description">
                Personal loan is an unsecured loan extended to individuals to meet their various financial requirements. It provides financial assistance without the requirement of collateral or security from the borrower. These unsecured loans are intended to serve various needs of people ranging from personal expenses to medical emergencies. The goal is to allow the buyers the flexibility of utilizing the funds as per their financial goals.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features/Benefits Section */}
      <section className="personal-features-section">
        <div className="personal-features-container">
          <h2 className="personal-features-heading">FEATURES/BENEFITS</h2>
          <div className="personal-features-content">
            <div className="personal-features-image-wrapper">
              <img src={PersonalLoanBody} alt="Personal Loan Features" className="personal-features-image" />
            </div>
            <div className="personal-features-list">
              <div className="personal-feature-item">
                <h3 className="personal-feature-title">MAXIMUM LOAN TENURE</h3>
                <p className="personal-feature-description">Loan can be availed for 12-48 months.</p>
              </div>
              <div className="personal-feature-item">
                <h3 className="personal-feature-title">LOAN AMOUNT OFFERED</h3>
                <p className="personal-feature-description">Avail personal loan starting from Rs. 5,000 upto Rs. 5 Lakhs.</p>
              </div>
              <div className="personal-feature-item">
                <h3 className="personal-feature-title">INTEREST RATES</h3>
                <p className="personal-feature-description">Interest rates start from 18%.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Eligibility and No Collateral Section */}
      <section className="personal-info-section">
        <div className="personal-info-container">
          <div className="personal-info-grid">
            <div className="personal-info-card">
              <h3 className="personal-info-title">ELIGIBILITY</h3>
              <p className="personal-info-text">
                Salaried as well as self-employed professionals can avail the loan.
              </p>
            </div>
            <div className="personal-info-card">
              <h3 className="personal-info-title">NO COLLATERAL/SECURITY</h3>
              <p className="personal-info-text">
                Apply for Personal Loans with no collateral or security.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Eligibility and Documents Section */}
      <section className="personal-eligibility-section">
        <div className="personal-eligibility-container">
          <div className="personal-tabs">
            <button 
              className={`personal-tab ${activeTab === 'eligibility' ? 'active' : ''}`}
              onClick={() => setActiveTab('eligibility')}
            >
              Eligibility Criteria
            </button>
            <button 
              className={`personal-tab ${activeTab === 'documents' ? 'active' : ''}`}
              onClick={() => setActiveTab('documents')}
            >
              Required Documents
            </button>
          </div>

          {activeTab === 'eligibility' && (
            <div className="personal-tab-content">
              <p className="personal-eligibility-text">
                An Indian citizen between the ages 21-60 years, having a valid ID proof is eligible to avail personal loan.
              </p>
            </div>
          )}

          {activeTab === 'documents' && (
            <div className="personal-tab-content">
              <div className="personal-documents-grid">
                <div className="personal-documents-card">
                  <h3 className="personal-documents-title">ID PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                  <ul className="personal-documents-list">
                    <li>Pan Card</li>
                    <li>Aadhaar Card</li>
                    <li>Passport</li>
                    <li>Driver's License</li>
                    <li>Voter's ID</li>
                  </ul>
                </div>
                <div className="personal-documents-card">
                  <h3 className="personal-documents-title">ADDRESS PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                  <ul className="personal-documents-list">
                    <li>Aadhaar Card</li>
                    <li>Passport</li>
                    <li>Driving License</li>
                    <li>Voter's ID</li>
                  </ul>
                </div>
                <div className="personal-documents-card">
                  <h3 className="personal-documents-title">INCOME PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                  <ul className="personal-documents-list">
                    <li>Last 3 month's Salary Slips/ Form 16/ Last 3 month's bank statement reflecting salary credits/Salary Certificate (If Salaried Individual)</li>
                    <li>Latest Income Tax Return (ITR) (If Self Employed Individual)</li>
                    <li>Last 3 month's bank statement is mandatory</li>
                  </ul>
                  <p className="personal-documents-note">
                    Residence Ownership Proof is Not mandatory.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Learn More Section */}
      <section className="personal-learn-more-section">
        <div className="personal-learn-more-container">
          <div className="personal-learn-more-content">
            <h2 className="personal-learn-more-title">Learn More About Our Services</h2>
            <p className="personal-learn-more-text">Reach out to us for inquiries.</p>
          </div>
          <a href="/contact" className="personal-contact-btn">Contact Us</a>
        </div>
      </section>
    </div>
  );
};

export default PersonalLoan;
